import { EmbeddedCheckout, EmbeddedCheckoutProvider } from '@stripe/react-stripe-js';
import React, { useEffect, useState } from 'react'

export default function CheckoutForm({ stripe, pagesClientSecret }) {
    const [ready, setReady] = useState(false);
    // Здесь мы используем focus trap.
    // Когда в Embedded Stripe Form включена интеграция с платежкой Link,
    //   форма примерно через 5 секунд после загрузки фокусируется на форме Stripe,
    //   вызывая автоскролл страницы к форме.
    // Мы не хотим такого поведения, поэтому здесь мы создаем фиктивный элемент
    //   и на 5 секунд приковываем фокус к нему.
    // История проблемы здесь: https://doboard.com/1/task/19277
    useEffect(() => {

        // сбрасываем флаг при изменении ключевых пропсов
        setReady(false);

        if (!stripe || !pagesClientSecret) return;

        // Ловим фокус
        const trapEl = document.createElement('input');
        trapEl.style.position = 'fixed';
        trapEl.style.opacity = '0';
        document.body.appendChild(trapEl);
        trapEl.focus();

        const cleanup = () => {
            trapEl.remove();
        };

        // Спустя 5 секунд освобождаем фокус
        const timeout = setTimeout(() => {
            cleanup();
        }, 5000);

        return () => {
            cleanup();
            clearTimeout(timeout);
        };
    }, [stripe, pagesClientSecret]);

    if (!stripe || !pagesClientSecret) {
        return null;
    }

    return (
        <div id="checkout">
            <EmbeddedCheckoutProvider
                key={pagesClientSecret}
                stripe={stripe}
                options={{ clientSecret: pagesClientSecret }}
            >
                <EmbeddedCheckout />
            </EmbeddedCheckoutProvider>
        </div>
    );
}
